import { api } from "@/comn";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import utils, { comnUtils } from "@/comn/utils";
import { ptlEnvs } from "../../../comn";

/*
 *  Drd Criteria Management Infomaion Service
 * !== DRD기준관리 정보 기능 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/crtr/exrt`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/sysm/drd-ctra`,
    nodes: [{ label: "Portal" }, { label: "System Management" }, { label: "Drd Criteria Management Infomaion" }],
};

export const URLS = {
    ptli0406001s: `${BASE.path}/ptli0406001s`, // Drd Criteria Management Infomaion List !== DRD기준관리 정보 목록 ==!
};

export const APIS = {
    // Retrieve a list of Drd Criteria Management Infomaion. !== DRD기준관리 정보 목록을 조회한다.==!
    getDrdCtraList: () => {
        return api.get(`${BASE.api}`, {});
    },

    getDrdCtraHistList: () => {
        return api.get(`${BASE.api}/hist`, {});
    },

    insertDrdCrta: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
};

// Drd Criteria Management Infomaion List Grid Schema !== DRD기준관리 정보 목록 그리드 스키마 ==!
export const SG_DRD_CTRA_LIST: TGridSchema = {
    id: "grid_drdCtraList",
    head: [
        { cells: [{ header: "L_COMN_PRMT_NM", binding: "comnPrmtNm", width: "20%" }] },
        { cells: [{ header: "L_COMN_PRMT_VAL_CN", binding: "comnPrmtValCn", width: "15%" }] },
        { cells: [{ header: "L_COMN_PRMT_DESC", binding: "comnPrmtDesc", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "comnPrmtNm", edit: false, align: "left" }] },
        { cells: [{ binding: "comnPrmtValCn", edit: true }] },
        { cells: [{ binding: "comnPrmtDesc", edit: false, align: "left" }] },
    ],
};

// Drd Criteria Management Infomaion List Grid Schema !== DRD기준 이력 정보 목록 그리드 스키마 ==!
export const SG_DRD_CTRA_HIST_LIST: TGridSchema = {
    id: "grid_drdCtraHistList",
    head: [
        { cells: [{ header: "L_HIST_SRNO", binding: "histSrno", width: "*" }] },
        { cells: [{ header: "L_DCLR_PRID_SETT_VAL", binding: "dclrPridSettVal", width: "*" }] },
        { cells: [{ header: "L_DCLR_NO_SETT_VAL", binding: "dclrNoSettVal", width: "*" }] },
        { cells: [{ header: "L_DCLR_HNDV_CNDT_VAL", binding: "dclrHndvCndtVal", width: "*" }] },
        { cells: [{ header: "L_LAST_MDFR_ID", binding: "lastMdfrId", width: "10%" }] },
        { cells: [{ header: "L_LAST_MDFY_DTM", binding: "lastMdfyDtm", width: "15%" }] },
    ],
    body: [
        { cells: [{ binding: "histSrno", edit: false }] },
        { cells: [{ binding: "dclrPridSettVal", edit: false }] },
        { cells: [{ binding: "dclrNoSettVal", edit: false }] },
        { cells: [{ binding: "dclrHndvCndtVal", edit: false }] },
        { cells: [{ binding: "lastMdfrId", edit: false, align: "left" }] },
        { cells: [{ binding: "lastMdfyDtm", edit: false, type: "datetime" }] },
    ],
};
